import React from 'react';
import loadable, { LoadableComponent } from '@loadable/component';

import { IApplicationCommonRootComponentProps } from '../../types/applicationRootComponent';
import { EPageName } from '../../constants/pages';

const LandingSellerAppLoadable = loadable(() => import('../../../landingSeller/containers/LandingSellerApp'), {
  resolveComponent: ({ LandingSellerApp }) => LandingSellerApp,
  ssr: true,
});

const LandingBuyerAppLoadable = loadable(() => import('../../../landingBuyer/containers/LandingBuyerApp'), {
  resolveComponent: ({ LandingBuyerApp }) => LandingBuyerApp,
  ssr: true,
});

const LOADABLE_APPS: Record<EPageName, LoadableComponent<IApplicationCommonRootComponentProps>> = {
  landingSeller: LandingSellerAppLoadable,
  landingBuyer: LandingBuyerAppLoadable,
};

/**
 * Корневой компонент приложения, асинхронно загружающий и отдающий нужный App для каждой страницы.
 * Использовать при рендере на сервере и гидрации на клиенте во всех фичах,
 * т.к. от этого зависит работа код-сплиттинга страниц.
 */
export const RootApplicationContainer: React.FC<IApplicationCommonRootComponentProps> = props => {
  const App = LOADABLE_APPS[props.context.custom.pageName];

  return <App {...props} />;
};
